module.exports = {
	folder: 'rgb(99, 163, 238)',
};
